module.exports = __webpack_public_path__ + "static/media/Generative-AI.689b2277.jpg";